export const updateSelectedStore = (map, selectedStore) => {
  if (!map) return;

  const sourceData = map.getSource("resellers")?._data;
  if (!sourceData) return;

  sourceData.features.forEach((feature) => {
    feature.properties.selectedId =
      feature.properties.id === selectedStore.properties.id
        ? feature.properties.id
        : undefined;
  });
  map.getSource("resellers").setData(sourceData);
};

export const scrollToView = (viewId) => {
  // Fermer le clavier en retirant le focus de l'élément actif
  if (document.activeElement) {
    document.activeElement.blur();
  }

  const headerHeight = 68;
  const element = document.getElementById(viewId);
  const yOffset = element.getBoundingClientRect().top + window.pageYOffset;
  window.scroll({
    top: yOffset - headerHeight,
    behavior: "smooth",
  });
};
